import AccessoryDrawer from 'components/accessories-page/accessory-drawer';
import DuctedAccessoryRows from 'components/equipment-page/ducted-accessory-rows';
import {
  AccessoryGroup,
  AccessoryPick,
  AccessoryPicks
} from 'utils/ducted-accessory-groups';

type DuctedRequiredAccessoriesProps = {
  systemUniqueId: string;
  groups: AccessoryGroup[];
  picks: AccessoryPicks;
  onPick: (accessoryTypeCode: string, pick: AccessoryPick) => void;
};

export default function DuctedRequiredAccessories({
  systemUniqueId,
  groups,
  picks,
  onPick
}: DuctedRequiredAccessoriesProps) {
  if (groups.length === 0) {
    return null;
  }

  return (
    <AccessoryDrawer
      title='Required Accessories'
      subtitle='Included with this system - pick between the options where more than one fits.'
      description='Accessories the matched equipment needs to operate, such as heat kits, expansion valves and conversion kits.'
      itemSelected
      notNeeded={false}
      handleNotNeeded={() => undefined}
      hideSwitch
      alwaysOpen
      required
    >
      <div className='flex flex-col gap-4 p-5'>
        <DuctedAccessoryRows
          groups={groups}
          picks={picks}
          onPick={onPick}
          radioName={`required-accessory-${systemUniqueId}`}
        />
      </div>
    </AccessoryDrawer>
  );
}
